var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.901,
    height: 9.903,
    viewBox: "0 0 9.901 9.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit-tools",
    d: "M6.6,8.663,8.849,6.417,3.417.984,1.171,3.231Zm2.456-1.85L7,8.873,10.088,9.9ZM.48,2.543l.39.39L3.118.683l-.39-.39a1,1,0,0,0-1.421,0L.48,1.121A1.01,1.01,0,0,0,.48,2.543Zm0,0",
    transform: "translate(-0.188 0.001)",
    fill: "#489ef4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.a49f5d6e696d9d7d5fd789ac99bae4c4.svg";
export { ForwardRef as ReactComponent };